import {
  Component,
  ElementRef,
  ViewChild,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SectionTitleComponent } from '../../../shared/components/section-title/section-title.component';
import {
  TestimonialCardComponent,
  TestimonialData,
} from '../../../shared/components/testimonial-card/testimonial-card.component';
import { CarouselControlsComponent } from '../../../shared/components/carousel-controls/carousel-controls.component';

@Component({
  selector: 'app-home-testimonials',
  standalone: true,
  imports: [
    CommonModule,
    SectionTitleComponent,
    TestimonialCardComponent,
    CarouselControlsComponent,
  ],
  templateUrl: './home-testimonials.component.html',
  styleUrls: ['./home-testimonials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTestimonialsComponent implements OnInit, OnDestroy {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLElement>;
  private autoScrollInterval: any;
  private platformId = inject(PLATFORM_ID);

  testimonials: TestimonialData[] = [
    {
      id: '1',
      name: 'Derek Smart',
      role: 'Yacht Owner',
      image:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80',
      text: 'I had a great experience overall and couldn’t ask for a more professional salesperson. Every expectation met and surpassed. Highly recommend Stephen and League City Yacht Sales.',
      rating: 5,
    },
    {
      id: '2',
      name: 'Andrew Bower',
      role: 'First-Time Buyer',
      image:
        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80',
      text: 'Quick and easy experience! I very highly recommend!',
      rating: 5,
    },
    {
      id: '3',
      name: 'Robert Richardson',
      role: 'Charter Client',
      image:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80',
      text: 'Excellent Service, we have utilized this brokerage on two occasions. Both vessels sold well within the contract.',
      rating: 5,
    },
    {
      id: '4',
      name: 'Cindy Yancy',
      role: 'Sailing Enthusiast',
      image:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80',
      text: 'League City Yacht Sales handled our distant buying of a unique boat quite well. I would use them again. Thanks League City Yacht Sales. God bless.',
      rating: 5,
    },
  ];

  ngOnInit() {
    this.startAutoScroll();
  }

  ngOnDestroy() {
    this.stopAutoScroll();
  }

  startAutoScroll() {
    if (!isPlatformBrowser(this.platformId)) return;

    // Clear existing to avoid duplicates
    this.stopAutoScroll();
    this.autoScrollInterval = setInterval(() => {
      this.scroll('right');
    }, 2000); // Loop every 2 seconds
  }

  stopAutoScroll() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  }

  // Called on user interaction (hover/click)
  pauseAutoScroll() {
    this.stopAutoScroll();
  }

  // Called when user leaves (resume after delay)
  resumeAutoScroll() {
    this.startAutoScroll();
  }

  scroll(direction: 'left' | 'right') {
    // Reset timer on manual interaction
    this.pauseAutoScroll();

    // Restart timer after action (optional, but cleaner to just wait for resume)
    // For click, we want to pause briefly then resume.
    // But the requirement says "if i not use ... for 5 seconds it should loop again".
    // Use a timeout to resume if no further interaction.
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => this.resumeAutoScroll(), 5000);
    }

    const container = this.scrollContainer.nativeElement;
    // Use card width + gap.
    // Need to measure dynamically or assume fixed. Card is ~400px usually + gap.
    // Let's scroll by one container width or card width.
    const cardWidth = 400;

    if (direction === 'left') {
      container.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    } else {
      // Check for loop
      const maxScroll = container.scrollWidth - container.clientWidth;
      // Tolerance
      if (container.scrollLeft >= maxScroll - 50) {
        // Snap back to start for "loop" effect
        container.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: cardWidth, behavior: 'smooth' });
      }
    }
  }
}
